import React, { useEffect, useState } from "react";
import { Input, message, Table, TableProps } from "antd";
import { IReferrerList } from "./types";
import { getColumns } from "./Columns";
import { InvoiceService } from "../../../services/Invoices/InvoiceService/InvoiceService";
import PageWrapper from "../../../Layout/PageWrapper";
import useDebounce from "../../../hooks/useDebounce";
import { GlobalButton } from "../../comman/GlobalButton.styles";
import { PlusOutlined } from "@ant-design/icons";
import AddReferrerModal from "./AddReferrerModal";

const ReferrerList: React.FC = () => {

	const [loading, setLoading] = useState<boolean>(false);
	const [referrerList, setReferrerList] = useState<IReferrerList[]>([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [searchValue, setSearchValue] = useState("");
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [params, setParams] = useState({
		pageNumber: 1,
		pageSize: 20,
		searchTerm: "",
		sortField: "",
		sortType: ""
	});

	const debouncedSearchTerm = useDebounce(searchValue, 500);

	useEffect(() => {
		setParams((prev) => ({
			...prev,
			searchTerm: debouncedSearchTerm,
			pageNumber: 1
		}));
	}, [debouncedSearchTerm]);

	useEffect(() => {
		getReferrerList();
	}, [params]);

	const getReferrerList = async () => {
		setLoading(true);
		try {
			const filteredParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== "" && v !== undefined));
			const res = await InvoiceService.getReferralList(filteredParams);
			const filteredData = res.data.data || [];
			setReferrerList(filteredData);
			setTotalRecords(res.data?.totalRecords || 0);
		} catch (error: any) {
			if (error?.status === 429) message.error("Too many requests. Please try again later.");
			else message.error(error?.response?.data?.message || "Something went wrong");
		} finally {
			setLoading(false);
		}
	};

	const handleTableChange: TableProps<IReferrerList>["onChange"] = (pagination, _, sorter) => {
		let sortField = "";
		let sortType = "";

		if (!Array.isArray(sorter)) {
			sortField = (sorter.field as string) || "";
			sortType = sorter.order === "ascend" ? "asc" : sorter.order === "descend" ? "desc" : "";
		}

		setParams({
			...params,
			pageNumber: pagination.current || 1,
			pageSize: pagination.pageSize || 20,
			sortField,
			sortType
		});
	};

	return (
		<>
			<PageWrapper
				title="Referrer List"
				headerRight={
					<GlobalButton icon={<PlusOutlined />} className="primary" onClick={() => setIsModalOpen(true)}>
						Add Referrer
					</GlobalButton>
				}
			>
				<Input placeholder="Search invoices" onChange={(e) => setSearchValue(e.target.value)} style={{ width: 300, marginBottom: 16 }} />
				<Table<IReferrerList>
					loading={loading}
					columns={getColumns()}
					dataSource={referrerList}
					pagination={{
						current: params.pageNumber,
						pageSize: params.pageSize,
						total: totalRecords,
						showSizeChanger: true,
						showQuickJumper: true
					}}
					onChange={handleTableChange}
					scroll={{ x: "max-content" }}
				/>
			</PageWrapper>

			<AddReferrerModal open={isModalOpen} onClose={() => setIsModalOpen(false)} onSuccess={getReferrerList} />
		</>
	);
};

export default ReferrerList;
